<template>
  <section>
    <PublicNavigation :showForm="showForm" />
    <!-- Main header -->
    <section class="main-header">
      <div class="container d-flex align-items-center">
        <div class="col-md-6 container-col">
          <div class="main-text">
            <h1>Fast access to top-level freelance IT professionals</h1>
            <p class="mb-5 mt-3">
              Do you need experienced developers for a project or long-term collaboration? Let us
              connect you with pre-vetted freelancing developers within your time zone right away!
            </p>
            <router-link to @click.native="showFormEvent('employer')" class="btn btn-secondary mt-2"
              >Find Freelancers</router-link
            >
            <router-link
              to
              @click.native="showFormEvent('employer')"
              class="btn btn-secondary ml-3 mt-2"
              >Register Account</router-link
            >
          </div>
          <ul class="list-inline">
            <li class="list-inline-item">✓ No starting fees</li>
            <li class="list-inline-item">✓ €30 — €50 per hour</li>
            <li class="list-inline-item">✓ Flexible conditions</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- Main header end -->
    <!-- about section -->
    <section class="about">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>WHY WORK WITH JOBSHARK?</h2>
            <p class="title-text">
              Within our community, we have a huge network of 100,000+ skilled developers and other
              IT professionals that we connect with our customers. The main part of our network
              resides in Eastern Europe and we present thoroughly qualified candidates that are
              available remotely based on your needs.
            </p>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="text-box">
                <div class="icon">
                  <img :src="require(`../../../public/img/landing-pages/Icon-21.png`)" />
                  <h3>COMPETENCE</h3>
                </div>
                <div class="text">
                  <p>
                    We connect you with the best developers for your specific needs. You receive
                    only candidates that are available and that have passed our deep qualification
                    process that includes coding tests.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-box">
                <div class="icon">
                  <img :src="require(`../../../public/img/landing-pages/Icon-23.png`)" />
                  <h3>EFFICIENCY</h3>
                </div>
                <div class="text">
                  <p>
                    The developers that you contract through us are normally available on full-time
                    basis and reside in your time zone. We have flexible conditions and normal
                    hourly rates are €30-50.
                  </p>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="text-box">
                <div class="icon">
                  <img :src="require(`../../../public/img/landing-pages/Icon-24.png`)" />
                  <h3>CONVENIENCE</h3>
                </div>
                <div class="text">
                  <p>
                    You receive the hand-picked candidates via our platform along with CVs, our
                    presentations and programming test reports. We arrange online meetings with the
                    candidates that you like.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row grey">
            <div class="col-md-10 mx-auto">
              <h4>Trusted by 200+ tech companies</h4>

              <carousel
                :autoplay="true"
                :nav="false"
                :items="8"
                :margin="40"
                :autoplayTimeout="1000"
                :responsive="{
                  0: { items: 2, nav: false },
                  576: { items: 3, nav: false },
                  768: { items: 3, nav: false },
                  992: { items: 4, nav: false },
                  1200: { items: 7, nav: false },
                }"
              >
                <img
                  v-for="brand in brands"
                  :key="brand.id"
                  class="lgx-logo-img"
                  :src="require(`../../../public/img/homepage/customer-logos/${brand.src}`)"
                  style="max-width: 350px; max-height: 350px"
                  :alt="brand.alt"
                  :title="brand.alt"
                />
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="about">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              WHAT SKILLS ARE YOU<br />
              LOOKING FOR?
            </h2>
            <p class="title-text">
              We have our own roots in the software industry and our network consists of 100,000+ IT
              professionals with over 400 competencies in their portfolios. Most of them are based
              in Eastern Europe. They cover all major software development areas including .NET,
              Java, JavaScript, PHP, Kotlin, Swift, etc. We can also connect you with skilled
              freelancers in other areas such as DevOps, QA, design, technical support, and
              technical sales.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="statistics">
      <div class="container">
        <div class="row">
          <div class="col-md-11 mx-auto">
            <ul class="list-inline d-flex justify-content-between">
              <li
                v-for="(competence, index) in topCompetences"
                v-bind:key="competence.id"
                class="list-inline-item d-flex align-items-center"
              >
                <div class="text">
                  <i
                    v-if="competence.devicon !== null"
                    :class="`${competence.devicon} colored`"
                  ></i>
                  <img v-else src="/img/comstream.svg" alt="Jobshark logo" />
                  <span>
                    <number
                      animationPaused
                      :ref="`col${index}`"
                      :format="theFormat"
                      :to="competence.counter"
                      :duration="3"
                      easing="Power1.easeOut"
                      @complete="completed"
                      @click="playAnimation(`col${index}`)"
                    />
                  </span>
                  <IntersectionObserver
                    v-if="index === 0"
                    sentinal-name="sentinal-name"
                    @on-intersection-element="onIntersectionElement"
                  ></IntersectionObserver>
                  {{ competence.name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="about">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              HOW DOES IT WORK?
            </h2>
            <p class="title-text">
              We provide personal service and are collaborating with you through our platform. We
              match you with hard-to-find senior specialists who understand your industry and
              technical requirements. These are the simple steps to find and contract skilled
              freelancers:
            </p>
          </div>
          <div class="boxes">
            <div class="col-md-9 mx-auto">
              <div class="how-box">
                <div class="row">
                  <div class="col-md-4">
                    <div class="text">
                      <h2>Register an account in Jobshark</h2>
                      <p>
                        Registering into Jobshark is quick and easy, it only takes a minute.
                      </p>
                      <span class="count">1</span>
                    </div>
                  </div>
                  <div class="col-md-6 ms-auto">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/register-profile.png"
                      alt="Jobshark logo"
                    />
                  </div>
                </div>
              </div>

              <div class="how-box">
                <div class="row">
                  <div class="col-md-6">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/2.jpeg"
                      alt="Jobshark logo"
                    />
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="text">
                      <h2>Fill in your specific requirements and needed skill set</h2>
                      <p>
                        Share your specific prerequisites such as competence needed, seniority and
                        duration of the project.
                      </p>
                      <span class="count">2</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="how-box">
                <div class="row">
                  <div class="col-md-4">
                    <div class="text">
                      <h2>Get your personally matched developers</h2>
                      <p>
                        Receive a selection of handpicked, ready-to- work developers for your
                        consideration through the platform, along with CVs, our custom profile
                        report, technical test results and hourly rates.
                      </p>
                      <span class="count">3</span>
                    </div>
                  </div>
                  <div class="col-md-6 ms-auto">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/3.jpg"
                      alt="Jobshark logo"
                    />
                  </div>
                </div>
              </div>

              <div class="how-box">
                <div class="row">
                  <div class="col-md-6">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/4.png"
                      alt="Jobshark logo"
                    />
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="text">
                      <h2>Meet the freelancers</h2>
                      <p>
                        We'll set up video meetings with the candidates you're interested in. And
                        don't worry, we won't interfere unless you want us to.
                      </p>
                      <span class="count">4</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="how-box">
                <div class="row">
                  <div class="col-md-4">
                    <div class="text">
                      <h2>Contract the freelancers</h2>
                      <p>
                        Tell us who you want to contract, and we’ll proceed with that candidate to
                        make him/her available for you.
                      </p>
                      <span class="count">5</span>
                    </div>
                  </div>
                  <div class="col-md-6 ms-auto">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/5.png"
                      alt="Jobshark logo"
                    />
                  </div>
                </div>
              </div>

              <div class="how-box mb-0">
                <div class="row">
                  <div class="col-md-6">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/6.png"
                      alt="Jobshark logo"
                    />
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="text">
                      <h2>Work directly with the freelancers</h2>
                      <p>
                        You work directly with the developers like they are an extension of your
                        organization. The freelancers are using a time reporting system that we
                        provide for your transparency and convenience.
                      </p>
                      <span class="count">6</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-center">
          <button @click="showFormEvent('employer')" class="btn btn-secondary px-5 py-2">
            Get Started
          </button>
        </div>
      </div>
    </section>
    <!--End of about -->

    <section class="mid-section-white">
      <div class="container">
        <div class="row">
          <div class="col-md-5 ms-auto d-flex align-items-center">
            <div>
              <h3>HOW DO WE QUALIFY <br />OUR FREELANCERS</h3>
              <p>
                Our assessment team personally vet all Jobshark developers to ensure proficiency in
                programming, language &amp; soft skills.
              </p>
              <ul class="list-unstyled">
                <li>
                  <div class="icon"><i class="fas fa-check"></i></div>
                  In-depth interviews to assess soft skills, interpersonal skills, and technical
                  competence
                </li>
                <li>
                  <div class="icon"><i class="fas fa-check"></i></div>
                  Programming tests for developers on a 3rd party online coding platform
                </li>
                <li>
                  <div class="icon"><i class="fas fa-check"></i></div>
                  Reference checks
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-5">
            <img src="../../../public/img/homepage/working-freelancer.png" alt="managed services" />
          </div>
        </div>
      </div>
    </section>

    <section class="orange-boxes">
      <div class="container">
        <div class="row">
          <carousel
            :autoplay="true"
            :nav="false"
            :items="3"
            :responsive="{
              0: { items: 1, nav: false },
              576: { items: 1, nav: false },
              768: { items: 2, nav: false },
              992: { items: 3, nav: false },
              1200: { items: 3, nav: false },
            }"
          >
            <div v-for="(lancer, index) in freelancers" :key="index" class="col-md-12">
              <div class="text-box">
                <div class="content">
                  <div class="item">
                    <img
                      :src="`https://jobshark.eu/img/freelancers/${lancer.photo}`"
                      alt="freelancer"
                    />
                    <h3>{{ lancer.name }}</h3>
                    <ul class="list-unstyled">
                      <li v-for="comp in lancer.competence" :key="comp.id">{{ comp.name }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </carousel>
        </div>
      </div>
    </section>

    <section class="clouds">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 second">
            <div class="cloud" style="margin-top:30px">
              On-going contract with a minimum scope of 40 hours of work in total
            </div>

            <div class="cloud" style="margin-top:30px; margin-left:auto!important">
              Monthly invoicing at agreed hourly rate
            </div>

            <div class="cloud" style="position:absolute;bottom:0">
              Easy and fast to scale up and down as needed
            </div>
          </div>
          <div class="col-md-4">
            <div class="text-item">
              <h3>Flexible contracting model</h3>
              <div class="text-buble">
                <div class="price">
                  €30 — €50
                  <span>normal hourly rate for top-level developers</span>
                </div>
                <button @click="showFormEvent('employer')" class="btn btn-secondary">
                  Find Freelancers
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="cloud" style="margin-top:30px">
              No upfront nor starting fees
            </div>

            <div class="cloud" style="margin-top:30px; margin-left:auto!important">
              Time reporting tool for easy cost- tracking
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-7 mx-auto">
            <div class="reviews">
              <carousel :autoplay="true" :nav="false" :items="1" :autoplayTimeout="10000">
                <div v-for="review in reviews" :key="review.id" class="review-item">
                  <p>{{ review.review }}</p>
                  <span>{{ review.company }}</span>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Middle Orange Section -->
    <section class="mid-section">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              Agile Talent Acquisition: Unlocking Global Expertise, Breaking Boundaries
            </h2>
            <p>
              Times have indeed changed ever since the global pandemic, significantly changing work
              dynamics towards hybrid and remote setups. As a result, skilled developers are
              increasingly difficult to come by, and they prefer to work remotely. The result? Costs
              and hiring times are increasing. Fast. Recognizing this challenge, we offer a solution
              focused on tapping into talent globally, emphasizing expertise over location. Despite
              the hesitation, embracing remote developers is crucial for business growth; we're here
              to guide companies through this transition, ensuring access to top-tier talent for
              sustained success.
            </p>
            <div class="mx-auto col-md-4">
              <a
                target="_blank"
                href="https://jobshark.eu/whitepapers/Agile_Talent_Aquisition.pdf"
                download="Agile Talent Aquisition.pdf"
                class="btn btn-secondary"
                >Download Full Report</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="what-we-offer">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="intro">
              <h2>What we offer</h2>
              <p>
                We provide growth companies with suitable, high-performing candidates for projects
                or long-term engagements
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-25.png`)" />
              </div>
              <h3>Convenient Every Step of the Way</h3>
              <p>
                Experience a convenient hiring process that dynamically scales your team, reducing
                overheads, administrative tasks, and avoids compliance issues.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-24.png`)" />
              </div>
              <h3>Sizeable Return on Investment</h3>
              <p>
                Benefit from a simple, flexible commercial model, with material savings compared
                with traditional consultancy models.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-09.png`)" />
              </div>
              <h3>Hard-to-find Specialists</h3>
              <p>
                Fill the most in-demand roles with tech freelancers specializing in over 400
                competencies across engineering, data, DevOps, AI, and more.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-17.png`)" />
              </div>
              <h3>Speedy Hiring</h3>
              <p>
                Available developers within all major tech stacks including .NET, Java, PHP, Python,
                JavaScript, Kotlin, Swift, etc.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-19.png`)" />
              </div>
              <h3>Smooth Collaboration</h3>
              <p>
                Expand your distributed team seamlessly within your time zone while enjoying a
                simple recruitment process powered by our modern platform.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-22.png`)" />
              </div>
              <h3>Handpicked Talent</h3>
              <p>
                Our team of recruiting experts personally selects and nurtures top tech talent,
                ensuring they are qualified, tested, and readily available.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="intro">
              <h2>FREQUENTLY ASKED QUESTIONS</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="accordion" id="accordionPanelsStayOpenExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    How long does it take to hire a developer?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div class="accordion-body">
                    Registration takes a minute, and after telling us your specific requirements we
                    start presenting suitable developers within a few working days most often. You
                    decide who of the candidates should be contracted of course.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    What type of technical expertise does the Jobshark network offer?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div class="accordion-body">
                    We have an extensive network of senior developers covering over 400
                    competencies. This includes backend developers proficient in PHP, .NET, C#,
                    Python, Ruby, Golang, and Java, as well as frontend developers experienced in
                    React.js, Vue.js, and Angular, etc. Additionally, we collaborate with designers,
                    QA specialists, DevOps Engineers, BI experts, etc.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    How do I collaborate with the developers?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingThree"
                >
                  <div class="accordion-body">
                    Jobshark finds and connects you with the right expertise and we are happy to
                    facilitate the collaboration as needed. But you manage the developers as if they
                    were your employees in the daily work.
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseFour"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseFour"
                  >
                    Do the developers speak English?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingFour"
                >
                  <div class="accordion-body">
                    Yes, all our developers speak English fluently.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="accordion" id="accordionPanelsStayOpenExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseFive"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseFive"
                  >
                    How much does it cost to hire a Jobshark developer?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingFive"
                >
                  <div class="accordion-body">
                    The hourly price normally ranges from €30-50 for an ongoing collaboration with a
                    senior developer. We will present the exact price per developer.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingSix">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseSix"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseSix"
                  >
                    How do payment and administrative processes work?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingSix"
                >
                  <div class="accordion-body">
                    We invoice for the conducted work at the end of each calendar month with payment
                    terms 20 days. There are no up-front or advance payments.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingSeven">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseSeven"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseSeven"
                  >
                    How many hours per week can I engage Jobshark developers for?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseSeven"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingSeven"
                >
                  <div class="accordion-body">
                    Jobshark provides access to top developers who are normally eager to commit to
                    full-time projects. That being said, we recognize this may not always align with
                    your needs. Hence, we offer flexibility, with a minimum commitment of 40 hours
                    in total.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingEight">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseEight"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseEight"
                  >
                    How do I track costs and is it a flexible model?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseEight"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingEight"
                >
                  <div class="accordion-body">
                    You have access to a time reporting system to track the time spent by the
                    freelancers. The contract is flexible and is either time-limited or with a
                    shorter notice period.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="black-section">
      <div class="col-md-8 mx-auto">
        <div class="d-flex items-center">
          <img src="https://jobshark.eu/img/mail-logo.png" />
          <div class="text d-flex w-100">
            <div style="width:100%">
              <h4>Want to get started?</h4>
              <p>
                Register with us and you will soon be able to review top-level candidates!
              </p>
              <button @click="showFormEvent('employer')" class="btn btn-secondary">
                Find freelancers
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </section>
</template>

<script>
import PublicNavigation from '@/components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import IntersectionObserver from '@/components/common/IntersectionObserver';
import axios from 'axios';
import titleMixin from '../../mixins/titleMixin';
import { BRANDS } from '../../constants';
import carousel from 'vue-owl-carousel';
export default {
  mixins: [titleMixin],
  title() {
    return 'Find your Tech Freelancers | Jobshark';
  },
  description() {
    return 'Jobshark has a unique network of skilled tech freelancers. We find the right individuals in your time zone in areas such as .NET, Java, PHP, JavaScript, Android, iOS, etc';
  },
  canonicalLink() {
    return 'https://jobshark.eu/freelancers';
  },
  components: {
    PublicNavigation,
    Footer,
    carousel,
    IntersectionObserver,
  },
  data: () => ({
    interval: null,
    topCompetences: [],
    inViewport: {
      now: false, // Is some part of the component currently in the viewport?
      fully: false, // Is the component completely in the viewport?
      above: false, // Is any part of the component above the viewport?
      below: false, // Is any part of the component below the viewport?
    },
    showForm: {
      formType: '',
      count: 0,
    },
    isLoading: true,
    isSending: false,
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    reToken: '',
    tracking_code: null,
    brands: BRANDS,
    freelancers: [
      {
        name: 'Adelina',
        photo: 'Adelina.png',
        competence: [
          { id: 1, name: 'UX/UI Designer' },
          { id: 2, name: 'UX/UI Design, Figma, User Personas' },
        ],
      },
      {
        name: 'Aleksandar',
        photo: 'Aleksandar.png',
        competence: [
          { id: 1, name: 'Java Developer' },
          { id: 2, name: 'Java, Spring, SQL, AWS' },
        ],
      },
      {
        name: 'Branislav',
        photo: 'Branislav.png',
        competence: [
          { id: 1, name: 'Full-stack Developer' },
          { id: 2, name: '.NET, JavaScript, Angular' },
        ],
      },
      {
        name: 'Nikola',
        photo: 'Nikola.png',
        competence: [
          { id: 1, name: 'Android Developer' },
          { id: 2, name: 'Kotlin, Java, Unity3D, MySQL' },
        ],
      },
      {
        name: 'Boban',
        photo: 'Boban.png',
        competence: [
          { id: 1, name: 'Java Developer' },
          { id: 2, name: 'Java, Spring Boot, SQL, Azure' },
        ],
      },
      {
        name: 'Filip',
        photo: 'Filip.png',
        competence: [
          { id: 1, name: '.NET Developer' },
          { id: 2, name: '.NET Core, SQL, JavaScript, React Native' },
        ],
      },
      {
        name: 'Dien',
        photo: 'Dien.png',
        competence: [
          { id: 1, name: 'DevOps Engineer' },
          { id: 2, name: 'AWS, Azure DevOps, Terraform' },
        ],
      },
      {
        name: 'Haris',
        photo: 'Haris.png',
        competence: [
          { id: 1, name: 'Development Team Lead' },
          { id: 2, name: 'Java, Python, .NET, SQL' },
        ],
      },
      {
        name: 'Nhung',
        photo: 'Nhung.png',
        competence: [
          { id: 1, name: 'Front-end Developer' },
          { id: 2, name: 'React.js, JavaScript, SQL' },
        ],
      },
      {
        name: 'Adnan',
        photo: 'Adnan.png',
        competence: [
          { id: 1, name: 'Java Developer' },
          { id: 2, name: 'Java, Spring Boot, Apache Kafka' },
        ],
      },
      {
        name: 'Branko',
        photo: 'Branko.png',
        competence: [
          { id: 1, name: 'iOS Developer' },
          { id: 2, name: 'Swift, Objective-C, MVC' },
        ],
      },
      {
        name: 'Kreshnik',
        photo: 'Kreshnik.png',
        competence: [
          { id: 1, name: 'Full-stack Developer' },
          { id: 2, name: 'Java, Spring Boot, Angular' },
        ],
      },
      {
        name: 'Milos',
        photo: 'Milos.png',
        competence: [
          { id: 1, name: 'Front-end Developer' },
          { id: 2, name: 'React.js, TypeScript, Next.js' },
        ],
      },
      {
        name: 'Oket',
        photo: 'Oket.png',
        competence: [
          { id: 1, name: 'Full-stack Developer' },
          { id: 2, name: 'Groovy on Grails, Spring Boot, React.js' },
        ],
      },
      {
        name: 'Predrag',
        photo: 'Predrag.png',
        competence: [
          { id: 1, name: 'Java Developer' },
          { id: 2, name: 'Java, Microservices, Spring MVC' },
        ],
      },
      {
        name: 'Radoslav',
        photo: 'Radoslav.png',
        competence: [
          { id: 1, name: 'React Developer' },
          { id: 2, name: 'React.js, TypeScript, JavaScript' },
        ],
      },
      {
        name: 'Milovan',
        photo: 'Milovan.png',
        competence: [
          { id: 1, name: 'React Native Developer' },
          { id: 2, name: 'React Native, React.js, JavaScript' },
        ],
      },
    ],
    reviews: [
      {
        id: 1,
        company: 'HR Manager & Co-founder at Footway',
        logo: 'Footway.png',
        review:
          '“As a growth company we needed an active and service minded partner on the HR side. We found that in Jobshark and are very pleased with our collaboration.”',
      },
      {
        id: 2,
        company: 'Game Producer at Filimundus',
        logo: 'Filimundus.png',
        review:
          '“Jobshark provided us with much better results than other jobsites that we have used. Their platform is very easy to use and simplifies the entire recruiting process.”',
      },
      {
        id: 3,
        company: 'Head of Development at Tradedoubler',
        logo: 'Tradedoubler-1024x123.png',
        review:
          '“Building a really strong tech team is crucial for all software companies. I can honestly say that our long-term collaboration with Jobshark has helped us to reach there.”',
      },
      {
        id: 4,
        company: 'HR Business Partner at Sokigo',
        logo: 'sokigo.png',
        review:
          '“In recruitment you need to truly understand the business needs of your organization. Jobshark has an ability to do that, and we’ve had a great collaboration over many years.”',
      },
      {
        id: 5,
        company: 'Manager Technical Ops and Infrastructure at Sovos',
        logo: 'sovos.png',
        review:
          '“At Sovos, we look for the right technical competence no matter where these individuals are based. Jobshark is a great partner to facilitate that.”',
      },
    ],
  }),
  methods: {
    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },
    handleClick() {
      this.$refs.form.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    },

    onIntersectionElement() {
      const colsList = Object.keys(this.$refs);

      colsList.forEach(item => {
        if (this.$refs[item][0] && typeof this.$refs[item][0].play === 'function') {
          this.$refs[item][0].play();
        }
      });
    },
    theFormat(number) {
      return number.toFixed(0);

      /* return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','); */
    },
    completed() {
      //  console.log('Animation ends!');
    },
    playAnimation(col) {
      this.$refs[col].play();
    },
    getTopTenCompetences() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/competence/topcompetences`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.topCompetences = data;
          /*   if (window.innerWidth >= 601 && window.innerWidth <= 768) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth <= 601) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth >= 769 && window.innerWidth <= 992) {
            this.topCompetences = data.slice(0, -4);
          }
          if (window.innerWidth > 1000) {
            this.topCompetences = data.slice(0, -1);
          } */
        });
    },
  },
  mounted() {
    this.getTopTenCompetences();
    if (this.$route.query.utm_id) {
      this.tracking_code = this.$route.query.utm_id;
    }
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';
.grey {
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}
.container {
  max-width: 1320px;
}
h2 {
  text-transform: uppercase;
  font-size: 28px;
  margin-bottom: 15px;
}

p {
  color: #575757;
  font-size: 16px;
  font-family: $font-family-sans-lato;
}
.main-header {
  height: 70vh;
  background: url('../../../public/img/homepage/header-freelancer.png');
  background-size: cover;
  margin-top: 70px;
  .container {
    position: relative;
    height: 70vh;
    flex-wrap: wrap;
    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;
      span {
        display: block;
      }
    }
    p {
      color: #fff !important;
      font-size: 18px;
      font-weight: 400;
    }
    .btn-secondary {
      padding: 10px 55px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 6px;
      &:nth-of-type(2) {
        color: #000;
        margin-left: 12px;
        background: #fff;
        border: none !important;
      }
    }
  }
  .container-col {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
  }
  .list-inline {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
}

.clouds {
  background-image: linear-gradient(to bottom, #008fb2, white);
  min-height: 620px;
  padding: 80px 20px;
  .col-md-4 {
    position: relative;
    height: 460px;
  }
  .text-item {
    h3 {
      color: #fff;
      text-align: center;
      font-weight: 700;
      font-size: 24px;
      margin-bottom: 40px;
    }
    .text-buble {
      background-color: #fff;
      padding: 32px 0px;
      border-radius: 42px;
      text-align: center;
      .price {
        font-size: 32px;
        font-weight: 700;
        margin: 0 0 30px 0;
        span {
          display: block;
          font-weight: 400;
          font-size: 14px;
          color: #666;
        }
      }
      .btn-secondary {
        font-weight: 600;
      }
    }
  }
  .cloud {
    background: rgba(255, 255, 255, 0.9);
    width: 300px;
    height: 100px;
    border-radius: 150px;
    box-shadow: 10px 10px rgba(0, 0, 0, 0.2);
    animation: move 3s infinite;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    padding: 0 12px;
    justify-content: center;
    text-align: center;
  }

  .cloud:after {
    content: '';
    background: rgba(255, 255, 255, 0.9);
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    top: -50px;
    left: 50px;
    z-index: -1;
  }

  .cloud:before {
    content: '';
    background: rgba(255, 255, 255, 0.9);
    position: absolute;
    width: 170px;
    height: 150px;
    border-radius: 50%;
    top: -90px;
    right: 40px;
    z-index: -1;
  }

  @keyframes move {
    0% {
      transform: translatex(0);
    }
    50% {
      transform: translatex(-10px);
    }
  }
  .reviews {
    position: relative;
    border-radius: 22px;
    background-color: rgb(242, 102, 34);
    margin-top: -40px;
    padding: 40px;
    .review-item {
      text-align: center;
      display: block;
      img {
        width: 180px;
        height: auto;
        display: block;
        margin: 0 auto 30px auto;
        filter: grayscale(100%);
      }
      p {
        color: #fff;
        font-size: 21px;
        font-style: italic;
      }
      span {
        display: block;
        color: #fff;
        font-weight: 700;
        margin: 30px 0;
        font-size: 18px;
      }
    }
  }
}

.about {
  padding: 60px 0;
  h2 {
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;
    font-size: 31px;
  }
  h4 {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 30px;
    font-size: 41px;
    color: #666;
  }
  .title-text {
    text-align: center;
    font-size: 19px;
    span {
      display: block;
    }
  }
  .text-box {
    margin: 40px 0;
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0 20px 0;
      img {
        width: 72px;
        height: 72px;
        margin-right: 15px;
        object-fit: cover;
      }
      h3 {
        color: #000;
        font-size: 21px;

        text-transform: uppercase;
        font-weight: 700;
        align-self: flex-end;
      }
    }
    .text {
      text-align: center;
      p {
        font-size: 16px;
      }
    }
  }
  .boxes {
    margin-top: 80px;
    .how-box {
      text-align: left;
      position: relative;
      margin-bottom: 100px;
      .text {
        position: relative;
        h2 {
          position: relative;
          z-index: 9;
          text-align: left;
          text-transform: none;
          font-size: 24px;
        }
        p {
          position: relative;
          z-index: 9;
        }
        .count {
          position: absolute;
          bottom: 0;
          right: -80px;
          font-size: 280px;
          font-weight: 900;
          color: #ebeced;
          z-index: 0;
          height: 100px;
          opacity: 0.8;
          line-height: 0;
        }
      }
    }
  }
}

.statistics {
  padding: 20px 0 30px 0;

  h2 {
    margin-bottom: 30px;
  }

  .list-inline {
    margin: 0;
    font-family: $font-family-sans-lato;
    flex-wrap: wrap;

    li {
      width: 20%;
      text-align: center;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      width: 105px;
      height: 105px;
      color: #888;
      border-radius: 6px;
      -webkit-box-shadow: 0px 15px 35px #0000000d;
      box-shadow: 0px 15px 35px #0000000d;
      background: #fff;

      .text {
        width: 100%;

        span {
          display: block;
          margin: 4px auto;
          font-weight: 700;
          color: #575757;
        }

        i {
          display: block;
          font-size: 41px;
        }

        img {
          width: 42px;
          height: 42px;
        }
      }
    }
  }
}

.mid-section {
  padding: 80px 0;
  background: #008fb2;
  color: #fff;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
    position: relative;

    img {
      margin: -12px 10px 0 0;
    }
  }

  p {
    text-align: center;
    color: #fff;
  }

  .btn-secondary {
    background: #fff;
    border-color: #fff;
    margin: 50px auto 0 auto;
    padding: 8px 25px;
    width: auto;
    display: block;
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }
}

.mid-section-white {
  padding: 60px 0 60px 0;
  color: #000;
  background: rgba(0, 0, 0, 0.05);
  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  h3 {
    text-transform: uppercase;
    font-size: 28px;
    margin-bottom: 15px;
  }
  p {
    color: #575757;
    font-size: 16px;
  }
  .list-unstyled {
    li {
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        margin-right: 12px;
        font-size: 18px;
        color: #f26622;
      }
    }
  }
}

.orange-boxes {
  padding: 80px 0;
  .text-box {
    position: relative;
    background: #f26622;
    padding-bottom: 70%;
    border-radius: 12px;
    text-align: center;
    color: #fff;
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      h3 {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 5px;
      }
      img {
        width: 94px;
        height: 94px;
        border-radius: 100%;
        display: block;
        margin: 0 auto 12px auto;
      }
    }
  }
}

.contact-us {
  margin-top: 80px;
  h2 {
    text-align: center;
    width: 80%;
    margin: 0 auto;
  }
  form {
    margin: 50px 0;
    .form-group {
      position: relative;
      .form-control {
        border-radius: 8px;
        min-height: 65px;
        font-size: 18px;
        font-family: $font-family-sans-lato;
      }
      span {
        position: absolute;
        display: flex;
        top: 0;
        right: 0;
        padding: 0 25px 0 0;
        height: 100%;
        align-items: center;
        justify-content: center;
        font-size: 21px;
        color: red;
      }
    }
    .btn-secondary {
      padding: 15px 0;
      font-size: 18px;
      margin-top: 20px;
    }
  }
}

.what-we-offer {
  .accordion-item {
    border: none !important;
    border-bottom: 1px solid #ddd !important;
    .accordion-button {
      font-weight: 600;
      font-size: 15px;
    }
  }
  .intro {
    text-align: center;
    padding: 80px 0;
    h2 {
      text-transform: uppercase;
      font-weight: 700;
    }
  }
  .text-box {
    text-align: center;
    margin-bottom: 50px;
    .icon {
      display: block;
      width: 92px;
      height: 92px;
      margin: 0 auto 20px auto;
      img {
        width: 92px;
        height: 92px;
        object-fit: cover;
      }
    }
    h3 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 15px;
    }
  }
}

.black-section {
  height: 360px;
  color: #000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  img {
    width: 200px;
    height: auto;
    margin-right: 40px;
    flex-shrink: 0;
  }
  .text {
    text-align: right;
    align-items: center;
    h4 {
      color: #000;
      font-weight: 600;
    }
    p {
      font-size: 18px;
      color: #000;
      span {
        display: block;
        color: #f26622;
      }
    }
    .btn-secondary {
      padding: 8px 55px;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}

@media only screen and (max-width: 992px) {
  .main-header {
    margin-top: 60px;
    height: auto !important;
    .container {
      height: auto;
      h1 {
        font-size: 28px;
        margin-top: 20px;
      }
      p {
        font-size: 15px;
      }
      .btn-secondary {
        display: block;
        margin: 12px 0 0 0 !important;
      }
    }
    .list-inline {
      position: relative;
      display: block !important;
      width: 100%;
      margin-top: 30px;
      li {
        width: 100%;
        margin-bottom: 12px;
      }
    }
  }
  .about {
    h4 {
      font-size: 21px;
      font-weight: 600;
    }
  }

  .clouds {
    .col-md-4 {
      height: auto !important;
      &.second {
        order: 2;
      }
    }
    .cloud {
      position: relative !important;
      margin: 12px 0 !important;
      animation: none !important;
      width: 100%;
      margin: 20px 0 !important;
      &::before {
        display: none !important;
      }
      &::after {
        display: none !important;
      }
    }
    .reviews {
      margin-top: 40px;
      .review-item {
        p {
          font-size: 15px;
        }
        span {
          font-size: 15px;
        }
      }
    }
  }
  .black-section {
    display: block !important;
    margin-top: 80px;
    .text {
      text-align: center !important;
    }
    img {
      display: none !important;
    }
  }
  .boxes {
    .how-box {
      &:first-of-type {
        .text {
          margin-bottom: 50px;
        }
      }
      &:nth-of-type(2) {
        .text {
          margin-bottom: 50px;
        }
        .col-md-6 {
          order: 1;
        }
      }
      &:nth-of-type(3) {
        .text {
          margin-bottom: 50px;
        }
      }
      &:nth-of-type(4) {
        .text {
          margin-bottom: 50px;
        }
        .col-md-6 {
          order: 1;
        }
      }
      &:nth-of-type(5) {
        .text {
          margin-bottom: 50px;
        }
      }
      &:nth-of-type(6) {
        .text {
          margin-bottom: 50px;
        }
        .col-md-6 {
          order: 1;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .main-header {
    margin-top: 60px;
    height: auto !important;
    .container {
      height: auto;
      h1 {
        font-size: 28px;
        margin-top: 20px;
      }
      p {
        font-size: 15px;
      }
      .btn-secondary {
        display: block;
        margin: 12px 0 0 0 !important;
      }
    }
    .list-inline {
      position: relative;
      display: block !important;
      width: 100%;
      margin-top: 30px;
      li {
        width: 100%;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
